<h2 mat-dialog-title class="cut-long-text">
    Testaufgabe <span class="name">{{ this.data.name }} </span>bearbeiten<span class="taskname">{{ taskName() | transloco }}</span>
</h2>
<br />
<mat-divider></mat-divider>
<mat-dialog-content class="content-container">
    @if (!playerService.iFrameReady) {
        <div class="spinner-overlay">
            <div class="spinner-overlay-content">
                <pixl-spinner></pixl-spinner>
            </div>
        </div>
    }

    <as-split direction="horizontal" class="split-container">
        <as-split-area #iframePane class="iframe-pane" [minSize]="getLeftAreaMinSize()" [size]="getLeftAreaSize()">
            <iframe #playerPreviewIframe [src]="iframePreviewUrl!" (load)="onIFrameLoaded()" tabindex="0" title="Player 2"></iframe>
        </as-split-area>
        @if (textPartVisible() || enumerationPartVisible() || enumPlaceholderPartVisible()) {
            <as-split-area class="editor-pane" [minSize]="25" [size]="50">
                <pixl-editor
                    [htmlString]="explanationContentHtml"
                    [editorHeight]="'98%'"
                    [bearerToken]="authToken!"
                    [assetUrl]="assetsUrl"
                    [mediaUrl]="mediaUrl"
                    [(editedHtmlString)]="explanationContentHtml"
                    (callbackFct)="callbackFct($event)"
                    [fixedMenu]="true"
                    [showAccounting]="accounting()"
                    [primaryColor]="playerContentMessage.config.playerSettings?.theme?.primaryColor ?? null"
                    [secondaryColor]="playerContentMessage.config.playerSettings?.theme?.secondaryColor ?? null"
                    [tertiaryColor]="playerContentMessage.config.playerSettings?.theme?.tertiaryColor ?? null"
                    [placeholderColor]="playerContentMessage.config.playerSettings?.theme?.placeholderColor ?? null"
                    [hoverColor]="playerContentMessage.config.playerSettings?.theme?.hoverColor ?? null"
                    [drawColor]="playerContentMessage.config.playerSettings?.theme?.drawColor ?? null"
                    [drawHighlightColor]="playerContentMessage.config.playerSettings?.theme?.drawHighlightColor ?? null"
                    [compareSolutionsBgColor]="playerContentMessage.config.playerSettings?.theme?.compareSolutionsBgColor ?? null"
                >
                </pixl-editor>
            </as-split-area>
        }
    </as-split>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
    <button mat-raised-button (click)="onCancel()">{{ "cancel" | transloco }}</button>
    <button mat-raised-button (click)="onSave()">{{ "save" | transloco }}</button>
</mat-dialog-actions>
